"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationPinIcon16Solid = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var BaseIcon_1 = require("../../internal/BaseIcon");
exports.LocationPinIcon16Solid = forwardRef_1.forwardRef('LocationPinIcon16Solid', function (props, ref) {
    return (react_1.default.createElement(BaseIcon_1.BaseIcon, tslib_1.__assign({ ref: ref, viewBoxSize: 16 }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.763 4.198C.75 8.15 3.99 11.809 6.8 14.852c.64.693 1.75.687 2.386-.008 2.78-3.034 6.027-6.614 4.087-10.57C12.276 2.237 10.255 1.001 8 1.001c-2.224 0-4.223 1.204-5.237 3.196ZM8 9.74a2.794 2.794 0 1 0 0-5.589 2.794 2.794 0 0 0 0 5.59Z" })));
});
